"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./index.less");
var _classnames = _interopRequireDefault(require("classnames"));
const insertRipple = props => {
  const {
    className,
    ref
  } = props;
  if (ref !== null && ref !== void 0 && ref.getElementsByClassName('ripple').length) return;
  const Ripple = document.createElement('div');
  Ripple.className = (0, _classnames.default)(className, 'ripple');
  ref === null || ref === void 0 || ref.appendChild(Ripple);
};
var _default = exports.default = insertRipple;